

















import { Component, Prop, Vue } from 'vue-property-decorator'
import { PropType } from 'vue'
import { TrelloCard } from '@/TrelloClient'
import DateTools from '@/DateTools'
import 'v-calendar/lib/v-calendar.min.css'

@Component({
    props: {
        cardId: String,
    },
})
export default class extends Vue {

    calendarVisible = false

    selectedDate = new Date()

    buttonHandler() {
        this.calendarVisible = !this.calendarVisible
        this.$store.dispatch('fetchActiveCard', (this as any).cardId)
    }

    inputHandler(date: Date) {
        date.setHours(12)
        let cardId = (this as any).cardId
        this.$store.state.trello.updateDueDate(cardId, date).then(() => {
            console.log('Data di scadenza aggiornata a ' + date.toISOString())
            this.calendarVisible = false
            // Render the new due date
            this.$store.commit('updateOpenCardDueDate', { cardId, dueDate: date.toISOString() })
        })
    }

}
